export function isCheckoutVerified(verification, form, custref) {
    return !!verification?.token && verification.formId === form?.id
        && verification.custref === custref && verification.expiresAt * 1000 > Date.now();
}
